import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ children, requiredRole = null }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuth, adminRole } = useSelector((state) => state.auth);

  useEffect(() => {
    // If not authenticated, redirect to login
    if (!isAuth) {
      localStorage.clear();
      navigate("/login", {
        state: { from: location.pathname },
        replace: true,
      });
      return;
    }

    // If requiredRole is specified, check if user has it
    if (requiredRole && adminRole) {
      const hasRequiredRole = Array.isArray(requiredRole)
        ? requiredRole.includes(adminRole)
        : adminRole === requiredRole;

      if (!hasRequiredRole) {
        navigate("/login", {
          state: { from: location.pathname },
          replace: true,
        });
        return;
      }
    }
  }, [isAuth, adminRole, navigate, location.pathname, requiredRole]);

  // Show children if authenticated and has required role (if specified)
  if (!isAuth) {
    return null; // Will redirect in useEffect
  }

  if (requiredRole && adminRole) {
    const hasRequiredRole = Array.isArray(requiredRole)
      ? requiredRole.includes(adminRole)
      : adminRole === requiredRole;

    if (!hasRequiredRole) {
      return null; // Will redirect in useEffect
    }
  }

  return children;
};

export default ProtectedRoute;
